<header class="sticky top-0 z-[70] w-full bg-transparent">
  <!-- Se oculta con visibility (no con @if) para no destruir/recrear el header durante la animación del sidebar -->
  <div [class.invisible]="isMobileSidebarOpen()">
    <div class="py-2 px-1 sm:px-3">
      <div
        class="h-16 w-full px-3 sm:px-4
               flex items-center gap-3
               rounded-2xl   bg-white shadow-sm
               dark:bg-dark-900
               dark:shadow-[0_10px_28px_rgba(0,0,0,0.35)]
               backdrop-blur-sm"
      >
        <div class="flex min-w-0 items-center gap-2 lg:hidden">
          <button
            type="button"
            (click)="toggleSidebarMenu()"
            [attr.aria-expanded]="isMobileMenuOpen()"
            aria-label="Abrir menú lateral"
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white text-slate-700 transition-colors hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            <i class="fa-solid fa-bars text-[16px]"></i>
          </button>
        </div>

        <div class="ml-auto flex h-full items-center justify-end gap-2 sm:gap-2.5">
          <!-- Toggle dark mode -->
          <button
            type="button"
            (click)="toggleDarkMode()"
            [attr.aria-pressed]="darkModeService.darkMode()"
            class="relative h-10 w-[84px] rounded-full bg-slate-100 shadow-sm transition-colors duration-300 outline-none focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 dark:bg-[#0B1220]"
          >
            <span
              class="pointer-events-none absolute inset-0 z-[1] grid h-full w-full grid-cols-2 place-items-center text-sm leading-none"
            >
              <i
                class="fa-solid fa-sun transition-colors duration-300"
                [ngClass]="
                  darkModeService.darkMode()
                    ? 'text-slate-500 opacity-100'
                    : 'text-amber-500 opacity-0'
                "
              ></i>
              <i
                class="fa-solid fa-moon transition-colors duration-300"
                [ngClass]="
                  darkModeService.darkMode()
                    ? 'text-slate-100 opacity-0'
                    : 'text-slate-500 opacity-100'
                "
              ></i>
            </span>

            <span
              class="absolute top-1/2 left-1 z-[2] h-8 w-8 -translate-y-1/2 rounded-full shadow-sm transition-colors duration-300 ease-out inline-flex items-center justify-center"
              [ngClass]="
                darkModeService.darkMode()
                  ? 'translate-x-[44px] bg-[#173fac] shadow-[0_6px_14px_rgba(29,78,216,0.4)]'
                  : 'translate-x-0 bg-white border border-slate-200'
              "
            >
              <i
                class="text-[14px] leading-none transition-colors duration-300"
                [ngClass]="
                  darkModeService.darkMode()
                    ? 'fa-solid fa-moon text-white'
                    : 'fa-solid fa-sun text-amber-500'
                "
              ></i>
            </span>
          </button>

          <app-sync-status></app-sync-status>

          <div class="relative">
            <button
              type="button"
              (click)="toggleCashSessionMenu($event)"
              [attr.title]="cashIndicatorTooltip()"
              [attr.aria-label]="cashIndicatorLabel()"
              class="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 shadow-sm transition-[background-color,color,box-shadow,transform] duration-200 leading-none hover:-translate-y-0.5 hover:bg-white hover:text-slate-800 hover:shadow-md dark:bg-slate-800 dark:text-slate-200 dark:shadow-none dark:hover:bg-slate-700 dark:hover:text-white"
            >
              <i class="fa-solid fa-cash-register text-[14px]"></i>
              <span
                class="absolute right-1 top-1 h-2.5 w-2.5 rounded-full border border-white dark:border-slate-900"
                [ngClass]="cashIndicatorDotClass()"
              ></span>
            </button>

            @if (isCashSessionMenuOpen) {
              <div
                class="absolute right-0 top-full z-30 pt-2"
              >
                <div
                  class="w-72 rounded-xl border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-800"
                >
                  @if (hasActiveCashSession()) {
                    <div class="space-y-3 px-4 py-4">
                      <div>
                        <p class="text-sm font-semibold text-slate-900 dark:text-white">
                          {{ cashSessionRegisterLabel() }}
                        </p>
                        <p class="mt-1 text-sm text-slate-500 dark:text-slate-300">
                          {{ formatCurrency(cashSessionCashAmount()) }} esperados en caja
                        </p>
                        <p class="mt-1 text-xs text-slate-500 dark:text-slate-400">
                          Abierta por {{ cashSessionOpenedBy() }}
                        </p>
                      </div>

                      <button
                        type="button"
                        (click)="goToCashSession($event)"
                        class="inline-flex w-full items-center justify-center rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-400"
                      >
                        Ir a caja
                      </button>

                      <button
                        type="button"
                        (click)="openCloseCashSessionModal($event)"
                        class="inline-flex w-full items-center justify-center rounded-lg border border-rose-300 bg-rose-50 px-4 py-2 text-sm font-semibold text-rose-700 transition-colors hover:bg-rose-100 dark:border-rose-500/40 dark:bg-rose-500/10 dark:text-rose-300 dark:hover:bg-rose-500/20"
                      >
                        Cerrar caja
                      </button>
                    </div>
                  } @else {
                    <div class="space-y-3 px-4 py-4">
                      <div>
                        <p class="text-sm font-semibold text-slate-900 dark:text-white">
                          No tienes caja abierta
                        </p>
                        <p class="mt-1 text-sm text-slate-500 dark:text-slate-300">
                          @if (allActiveCashRegistersOccupied()) {
                            Todas las cajas están ocupadas.
                          } @else {
                            Abre una caja para comenzar a operar.
                          }
                        </p>
                      </div>

                      <button
                        type="button"
                        (click)="openCashSessionModal($event)"
                        class="inline-flex w-full items-center justify-center rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-400"
                      >
                        Abrir caja
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Notifications -->
          @if (canDisplayProductNotifications()) {
            <div class="relative">
              <button
                type="button"
                (click)="toggleNotifications($event)"
                class="h-9 w-9 inline-flex items-center justify-center rounded-full bg-slate-100 text-slate-600 shadow-sm transition-[background-color,color,box-shadow,transform] duration-200 leading-none hover:-translate-y-0.5 hover:bg-white hover:text-slate-800 hover:shadow-md dark:bg-slate-800 dark:text-slate-300 dark:shadow-none dark:hover:bg-slate-700 dark:hover:text-white"
                aria-label="Notificaciones"
              >
                <i
                  class="text-[15px]"
                  [ngClass]="hasProductNotifications() ? 'fa-solid fa-bell text-amber-500' : 'fa-regular fa-bell'"
                ></i>
                @if (hasProductNotifications()) {
                  <span
                    class="absolute -right-1 -top-1 inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-rose-500 px-1 text-[11px] font-semibold text-white"
                  >
                    {{ notificationCountLabel() }}
                  </span>
                }
              </button>

              @if (isNotificationsOpen) {
                <div
                  class="absolute right-0 mt-2 z-30 w-[22rem] max-w-[calc(100vw-2rem)] rounded-xl border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-800"
                >
                  <div
                    class="flex items-center justify-between gap-3 border-b border-slate-200 px-4 py-3 dark:border-slate-700"
                  >
                    <div>
                      <p class="text-sm font-semibold text-slate-800 dark:text-slate-100">
                        Notificaciones
                      </p>
                      <p class="text-xs text-slate-500 dark:text-slate-400">
                        {{ productNotificationsCount() }} activas
                      </p>
                    </div>

                    @if (hasProductNotifications()) {
                      <button
                        type="button"
                        (click)="dismissAllNotifications($event)"
                        class="text-xs font-semibold text-rose-600 transition-colors hover:text-rose-700 dark:text-rose-400 dark:hover:text-rose-300"
                      >
                        Borrar todo
                      </button>
                    }
                  </div>

                  <div class="max-h-[28rem] overflow-y-auto">
                    @if (productNotificationsService.isLoading()) {
                      <div class="px-4 py-6 text-sm text-slate-500 dark:text-slate-400">
                        Cargando notificaciones...
                      </div>
                    } @else if (!hasProductNotifications()) {
                      <div class="px-4 py-6 text-sm text-slate-500 dark:text-slate-400">
                        No hay notificaciones pendientes.
                      </div>
                    } @else {
                      <div class="divide-y divide-slate-200 dark:divide-slate-700">
                        @for (notification of productNotifications(); track notification.id) {
                          <div class="px-4 py-3">
                            <div class="flex items-start gap-3">
                              <span
                                class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-700"
                              >
                                <i [class]="notificationIconClass(notification)"></i>
                              </span>

                              <button
                                type="button"
                                (click)="openNotification(notification, $event)"
                                class="group min-w-0 flex-1 rounded-xl px-2 py-1 -mx-2 -my-1 text-left transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 dark:hover:bg-slate-700/50"
                              >
                                <div class="flex items-start justify-between gap-3">
                                  <div class="min-w-0">
                                    <p class="text-sm font-semibold text-slate-800 transition-colors group-hover:text-slate-900 dark:text-slate-100 dark:group-hover:text-white">
                                      {{ notification.title }}
                                    </p>
                                    <p class="mt-1 text-sm text-slate-600 transition-colors group-hover:text-slate-700 dark:text-slate-300 dark:group-hover:text-slate-200">
                                      {{ notification.message }}
                                    </p>
                                    <span
                                      class="mt-2 inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-700 transition-[background-color,color,transform] group-hover:bg-primary-100 group-hover:text-primary-800 group-hover:translate-x-0.5 dark:bg-primary-500/10 dark:text-primary-300 dark:group-hover:bg-primary-500/20 dark:group-hover:text-primary-200"
                                    >
                                      {{ notification.actionLabel }}
                                      <i class="fa-solid fa-arrow-right text-[10px]"></i>
                                    </span>
                                  </div>
                                </div>
                              </button>

                              <button
                                type="button"
                                (click)="dismissNotification(notification, $event)"
                                class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-rose-600 dark:text-slate-500 dark:hover:bg-slate-700 dark:hover:text-rose-400"
                                [attr.aria-label]="'Borrar notificación de ' + (notification.productName || notification.title)"
                                title="Borrar notificación"
                              >
                                <i class="fa-solid fa-xmark text-sm"></i>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- User menu -->
          <div class="relative">
            <button
              type="button"
              (click)="toggleUserMenu($event)"
              class="h-9 w-9 inline-flex items-center justify-center rounded-full bg-slate-100 text-slate-700 shadow-sm transition-[background-color,color,box-shadow,transform] duration-200 leading-none hover:-translate-y-0.5 hover:bg-white hover:text-slate-800 hover:shadow-md dark:bg-slate-800 dark:text-slate-200 dark:shadow-none dark:hover:bg-slate-700 dark:hover:text-white"
              aria-label="Menú de usuario"
            >
              <i class="fa-regular fa-user text-[16px]"></i>
            </button>

            @if (isUserMenuOpen) {
              <div
                class="absolute right-0 mt-2 w-72 rounded-lg border border-slate-200 bg-white shadow-lg z-30 dark:border-slate-700 dark:bg-slate-800"
              >
                <div
                  class="px-3 py-2 text-sm border-b border-slate-200 text-slate-700 dark:border-slate-700 dark:text-slate-200"
                >
                  <p class="font-semibold">Bienvenido</p>
                  <p class="text-xs text-slate-500 dark:text-slate-400">{{ currentUserLabel() }}</p>
                </div>
                <div
                  class="border-b border-slate-200 px-3 py-2 text-sm text-slate-700 dark:border-slate-700 dark:text-slate-200"
                  (click)="$event.stopPropagation()"
                >
                  <p class="font-semibold">Sucursal actual</p>
                  <p class="text-xs text-slate-500 dark:text-slate-400">
                    {{ currentBranchLabel() }}
                  </p>

                  @if (branchesLoading()) {
                    <p class="mt-2 text-xs text-slate-500 dark:text-slate-400">
                      Cargando sucursales...
                    </p>
                  } @else if (hasMultipleBranches()) {
                    <label
                      for="header-branch-select"
                      class="mt-3 block text-xs font-medium text-slate-500 dark:text-slate-400"
                    >
                      Cambiar de sucursal
                    </label>
                    <select
                      id="header-branch-select"
                      class="mt-1 h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-700 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
                      [value]="company()?.id ?? ''"
                      (change)="selectBranch($event)"
                    >
                      @for (branch of branches(); track branch.id) {
                        <option [value]="branch.id">{{ branch.name }}</option>
                      }
                    </select>
                  }
                </div>
                <div class="py-1 text-sm">
                  <button
                    type="button"
                    (click)="goToMyAccount($event)"
                    class="w-full text-left px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700"
                  >
                    Perfil
                  </button>
                  @if (isAdmin()) {
                    <button
                      type="button"
                      (click)="goToBilling($event)"
                      class="w-full text-left px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700"
                    >
                      Plan y facturación
                    </button>
                  }
                  <button
                    type="button"
                    class="w-full text-left px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700"
                  >
                    Configuración
                  </button>
                  <button
                    type="button"
                    (click)="signOut()"
                    class="w-full text-left px-3 py-2 text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20"
                  >
                    Cerrar sesión
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
